import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  searchContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '24px',
  },
  reversedDirection: {
    flexDirection: 'row-reverse',
  },
  searchBar: {
    flexGrow: 1,
  },
  addNew: {
    flexGrow: 0,
  },
  table: {
    borderColor: palette.table.border,
    borderWidth: '1px',
    borderStyle: 'solid',
    overflow: 'auto',
    background: palette.table.background,
  },
  head: {
    backgroundColor: palette.table.header.background,
  },
  headCell: {
    color: palette.table.header.color,
    fontSize: '14px',
    fontWeight: 600,
  },
  row: {
    height: 80,
    '&:hover': {
      backgroundColor: palette.table.row.hover,
    },
  },
  filter: {
    width: '100%',
    display: 'flex',
    margin: '0px 0 30px 0',
  },
  hidden: {
    display: 'none !important',
  },
  wideFilterBar: {
    width: '100%',
  },
}), { name: 'ListTable' });
